// extracted by mini-css-extract-plugin
module.exports = {"climate-chart":"climate-chart_component_climate-chart__0L599"};